import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AuthService } from '../../../../@core/auth/auth.service';
import { environment } from '../../../../../environments/environment';

import { Observable, of } from 'rxjs';
import { InventoryPackageTypeDTO } from '../models/inventory-package-type';


@Injectable({
  providedIn: 'root'
})
export class InventoryPackageTypeService {
  protected basePath = '/';

  constructor(
    protected httpClient: HttpClient,
    private authService: AuthService,
  ) {
    this.basePath = environment.PLATFORM_API_URL;
  }

  public getAll(includeInactive: boolean = false) {

    let queryParameters = new HttpParams();

    if (includeInactive !== undefined && includeInactive !== null) {
      queryParameters = queryParameters.set('includeInactive', <any>includeInactive);
    }

    return this.httpClient.get<InventoryPackageTypeDTO[]>(`${this.basePath}/api/inventory/inventorypackagetypes`,
      {
        params: queryParameters
      }
    );
  }

  public getById(id: number): Observable<InventoryPackageTypeDTO> {
    return this.httpClient.get<InventoryPackageTypeDTO>(`${this.basePath}/api/inventory/inventorypackagetypes/${id}`);
  }

  public post(dto: InventoryPackageTypeDTO): Observable<InventoryPackageTypeDTO> {
    return this.httpClient.post<InventoryPackageTypeDTO>(`${this.basePath}/api/inventory/inventorypackagetypes`, dto);
  }

  public put(dto: InventoryPackageTypeDTO): Observable<InventoryPackageTypeDTO> {
    return this.httpClient.put<InventoryPackageTypeDTO>(`${this.basePath}/api/inventory/inventorypackagetypes/${dto.id}`, dto);
  }

  public delete(id: number): Observable<any> {
    return this.httpClient.delete(`${this.basePath}/api/inventory/inventorypackagetypes/${id}`);
  }

}
